// src/pages/AdminLogin.jsx
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import LoginForm from "../components/LoginForm";
import { logout as clearAuth } from "../services/authService";

export default function AdminLogin() {
  const nav = useNavigate();
  useEffect(() => { clearAuth(); }, []);   // ★ 社員トークンなどを消してからログイン

  return (
    <LoginForm
      title="管理者ログイン"
      accent="#0ea5e9"
      mode="admin"
      onSuccess={(user) => {
        if (!(user?.is_staff || user?.is_superuser)) {
          alert("管理者権限がありません。社員用ログインをご使用ください。");
          return;
        }
        nav("/dashboard", { replace: true });
      }}
    />
  );
}
